module.exports = __webpack_public_path__ + "media/images/gallery/constellations/scutum/sct_names-ffead73205813cd21f3bf3d0f3c204a7.gif";